import { EcommPayload } from '@/utils/analytics/ecommerce-events'
import { angelPartytownPlugin } from './angel-partytown-plugin'
import { type AnalyticsPlugin } from './types'

export function theatricalAngelPartytownPlugin() {
  const _theatricalAngelPartytownPlugin = angelPartytownPlugin({
    name: 'theatrical-angel-partytown-plugin Analytics Plugin',
    writeKey: process.env.NEXT_PUBLIC_THEATRICAL_SEGMENT_KEY,
    enabledDefault: false,
    enableRegex:
      /^https?:\/\/[-.a-zA-Z]+(:\d+)?\/(([a-z]+(-[a-zA-Z]+)?)\/)?(tickets|movies|pre-sales|giveaway|pay-it-forward)\/?/,
  })

  const plugin: AnalyticsPlugin = {
    ..._theatricalAngelPartytownPlugin,
    track: (params: {
      eventName: string
      payload: {
        event: string
        anonymousId: string
        properties: {
          experiments?: unknown
          funnel?: EcommPayload['funnel']
          projectSlug?: string
        }
      }
    }) => {
      if (
        !params?.payload?.properties?.funnel ||
        (params?.payload?.properties?.funnel &&
          !(params.payload.properties.funnel.includes('theatrical') || params.payload.properties.funnel === 'pif'))
      ) {
        return false
      }

      _theatricalAngelPartytownPlugin?.track?.({
        ...params,
        payload: {
          ...params.payload,
          event: `${params.payload.event} - ${params.payload.properties.funnel}`,
        },
      })
    },
  }

  return plugin
}
